module.exports = __webpack_public_path__ + "assets/banner.2a3cf867.svg";